import { PLAYER_IDS } from '../../shared/ceremony'
import { PixelFrame } from './pixel-frame'
import { Starfield } from './starfield'

// Full-screen message for the three moments nobody should see a broken page:
// no key in the link, a key the ceremony does not know, and the first connect.
const COPY = {
	missing: {
		title: 'INSERT KEY',
		body: "This is the private signing ceremony for the Gate Intelligence AB shareholders' agreement. Open the personal link you were sent; it carries your key.",
	},
	denied: {
		title: 'KEY NOT RECOGNISED',
		body: "This link's key is not on the guest list. Check that you opened the full link you were sent, or ask Jonas for a new one.",
	},
	loading: { title: 'CONNECTING', body: 'Reaching the ceremony ledger...' },
} as const

export function KeyScreen({ reason }: { reason: keyof typeof COPY }) {
	const c = COPY[reason]
	return (
		<main className="crt relative flex h-full flex-col items-center justify-center overflow-hidden bg-[radial-gradient(ellipse_at_50%_30%,#0a1340_0%,#04071a_70%)] px-6">
			<Starfield width={window.innerWidth} height={window.innerHeight} className="absolute inset-0 h-full w-full" />
			<div className="relative mb-6 flex items-end gap-4" aria-hidden>
				{PLAYER_IDS.map(id => (
					<img
						key={id}
						src={`/art/castle-${id}-dim.webp`}
						alt=""
						className="pixel h-[clamp(44px,8vw,84px)]"
						style={{ filter: 'brightness(0.62) saturate(0.7)' }}
					/>
				))}
			</div>
			<PixelFrame
				ink="var(--gold)"
				cut={12}
				className="w-full max-w-[640px]"
				contentClassName="items-center justify-center gap-5 px-6 py-8 text-center"
			>
				<h1 className="neon m-0 text-[clamp(44px,9vw,88px)] leading-none font-normal tracking-[0.1em] text-[var(--gold)]">
					{c.title}
					{reason === 'loading' && <span className="blink">_</span>}
				</h1>
				<p className="m-0 max-w-[34ch] text-[clamp(22px,3.4vw,30px)] leading-tight tracking-[0.04em] text-[var(--ink)]">
					{c.body}
				</p>
				{reason !== 'loading' && (
					<a
						href="/how-it-works/"
						className="text-[clamp(20px,2.8vw,24px)] leading-snug tracking-[0.08em] text-[var(--p2)] underline-offset-4 hover:underline"
					>
						HOW YOUR SIGNATURE MATTERS AND HOW THE PROOF IS RECORDED &gt;
					</a>
				)}
			</PixelFrame>
		</main>
	)
}
